<mat-icon class="close" (click)="close()">close</mat-icon>
<div class="container-fluid pt-2">
    <div class="Tabletitle">
        <span class="mt-5" style="font-size: 20px"> Delete team - {{selectedTeamName}} </span>
    </div>    
    <form #initiateForm="ngForm">
        <div *ngIf="isDocumentExist">
            <div style="margin-bottom: 4em;"class="card">
                <div class="card-body">
                    <h6>A team you are attempting to delete contains the following files. Please assign these files to another team before proceeding with the deletion</h6>
                </div>
            </div>
            <div *ngIf="teamList.length > 0" style="margin-bottom: 1em;">
                <button class="actionButton col-1" mat-stroked-button #authMenu
                    [matMenuTriggerFor]="assignOwner">Assign Team
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>                  
                <mat-menu #assignOwner="matMenu">
                    <button mat-menu-item *ngFor="let team of teamList" [value]="team.team_name"
                    (click)="assignTeam(team)">{{team.team_name}}<mat-icon *ngIf="selectedBackupTeamId == team.id">check</mat-icon></button>
                </mat-menu>
            </div>
            <div *ngIf="teamList.length == 0" style="color: red; padding-top: 0.2rem; margin-bottom: 1em">
                <h6>No another team is available to take back up, please create new team for back up and proceed to delete</h6>
            </div>
            <table aria-describedby="doc-table" mat-table [dataSource]="docResultsList" matSort>
                <ng-container matColumnDef="title">
                    <th id="title" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.documentName}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="create_date">
                    <th id="create_date" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded date </th>
                    <td mat-cell *matCellDef="let element"> {{element.createdDate | date }} </td>
                </ng-container>
                <ng-container matColumnDef="created_by">
                    <th id="created_by" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded By </th>
                    <td mat-cell *matCellDef="let element"> {{element.created_by }} </td>
                </ng-container>
                <ng-container matColumnDef="file_size">
                    <th id="file-size" mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
                    <td mat-cell *matCellDef="let element"> {{element.filesize}} </td>
                </ng-container>
                <!-- dynamic columns -->
                <ng-container *ngFor="let column of documentCols">
                    <ng-container *ngIf="column.indexOf('display_') === 0" matColumnDef="{{column}}">
                        <th id="{{column | stripDisplay}}" mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{column | stripDisplay}} </th>
                        <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
                    </ng-container>
                </ng-container>
                <!-- end dynamic columns-->

                <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                <!-- <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                </tr> -->
                <tr mat-row *matRowDef="let row; columns: documentCols;"
                    class="element-row"
                    title="Select Document">
                </tr>
            </table>
            <mat-paginator #myPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="10" showFirstLastButtons>
            </mat-paginator>
            <div *ngIf="loadNext" class="loadButton">
                <button mat-raised-button (click)=next()>Next 200<mat-icon>keyboard_arrow_right
                    </mat-icon></button>
            </div>
            <div *ngIf="loadPrevious" class="loadButton">
                <button mat-raised-button (click)=previous()>
                    <mat-icon>keyboard_arrow_left</mat-icon>Previous 200
                </button>
            </div>
            <button mat-raised-button (click)="onClose()" class="backButton m-2" style="float: right">Cancel</button>
            <button [disabled]="selectedBackupTeamId == 0" mat-raised-button (click)="deleteTeam()" class="actionButton m-2" style="float: right">Delete</button>
        </div>
        <div *ngIf="!isDocumentExist">
            <div class="card">
                <div class="card-body">
                    <h6>Are you sure you want to delete this team? Please confirm by selecting "Yes" to delete the team or "No" to cancel this action.</h6>
                </div>
            </div>
            <button mat-raised-button (click)="onClose()" class="backButton m-2" style="float: right">No</button>
            <button mat-raised-button (click)="deleteTeam()" class="actionButton m-2" style="float: right">Yes</button> 
        </div>

              
    </form>
     
</div>